<template>
  <div class="level">
    <router-link
      v-if="previous"
      :to="previous.to || {}"
      @click.native="$emit('clickPrevious')"
      class="level-left pr-8px has-text-weight-medium"
      style="flex-shrink: 1"
    >
      <span class="button is-small mr-8px">
        <span class="icon is-small"><i class="fas fa-chevron-left"></i></span>
      </span>
      {{ previous.label }}
    </router-link>
    <router-link
      v-if="next"
      :to="next.to || {}"
      @click.native="$emit('clickNext')"
      class="level-right ml-auto pl-8px has-text-right has-text-weight-medium"
      style="flex-shrink: 1"
    >
      {{ next.label }}
      <span class="button is-small ml-8px">
        <span class="icon is-small"><i class="fas fa-chevron-right"></i></span>
      </span>
    </router-link>
  </div>
</template>
<script>
/*
next/previous: {
  label: String,
  to: Object
}
*/

export default {
  props: {
    previous: Object,
    next: Object
  }
}
</script>